/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/7/9
 */
import request from 'utils/request'
import api from 'common/api/menu'

export async function current() {
    return request(api.current.url)
}
